import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss']
})

/**
 * PAges-404 component
 */
export class PolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
